import React from 'react';

const ExampleComponent = () => {
    return (
        <div>
            <h1>This is an Example Component</h1>
            <p>This component can be reused throughout the application.</p>
        </div>
    );
};

export default ExampleComponent;